import React from "react";

/** @typedef {'general' | 'pondFish' | 'sampling' | 'gallery' | 'table' | 'graph' | 'notes'} WorkflowSection */

const SECTION_META = {
  general: { title: "General", icon: "fa-cog" },
  pondFish: { title: "Fish Sampled/Caught", icon: "fa-fish" },
  sampling: { title: "Sampling Detail", icon: "fa-chart-line" },
  gallery: { title: "Gallery", icon: "fa-images" },
  table: { title: "Table view", icon: "fa-table" },
  graph: { title: "Graph view", icon: "fa-chart-area" },
  notes: { title: "Notes", icon: "fa-note-sticky" },
};

/**
 * Top header: primary title (matches active workflow tab) + subtitle + optional actions.
 */
export default function PondDetailWorkflowPageHeader({
  pondDetailId,
  section = "general",
  detailName,
  className = "",
  noBottomMargin = false,
  actions = null,
}) {
  const sid =
    pondDetailId != null && pondDetailId !== "" ? String(pondDetailId) : "";
  if (!sid) return null;

  const meta = SECTION_META[section] || SECTION_META.general;

  const namePart =
    detailName && String(detailName).trim()
      ? ` (${String(detailName).trim()})`
      : "";

  const subtitle = `Update Fishing / Sampling Data${namePart}`;

  return (
    <div
      className={`donezo-orders-toolbar donezo-upload-toolbar ${
        noBottomMargin ? "mb-0" : "mb-3"
      } ${className}`.trim()}
    >
      <div className="donezo-upload-toolbar__intro">
        <h1 className="donezo-orders-toolbar__title">{meta.title}</h1>
        <p className="donezo-upload-toolbar__subtitle">{subtitle}</p>
      </div>
      {actions ? <div className="donezo-orders-toolbar__actions">{actions}</div> : null}
    </div>
  );
}
